import type {AttachedDocument} from '@domain/refractory-product-catalog'
import {Button, Modal} from '@hm/fundamental'
import {mdiArrowLeftThin, mdiArrowRightThin} from '@mdi/js'
import {useState} from 'react'

import {useRefraModal} from '../../providers'

import {RefraCatalogDocumentPreview} from './RefraCatalogDocumentPreview'

interface RefraCatalogViewDocumentModalProps {
  refractoryId: number
  documents: AttachedDocument[]
}

export const RefraCatalogViewDocumentsModal: React.FC<RefraCatalogViewDocumentModalProps> = ({
  refractoryId,
  documents
}) => {
  const {closeModal} = useRefraModal()

  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(0)

  return (
    <Modal open onClose={closeModal} className="w-fit" data-cy="refra-catalog-view-documents-modal">
      <div className="flex justify-between items-center gap-4">
        <Button
          icon={mdiArrowLeftThin}
          variant="secondary"
          square
          disabled={currentDocumentIndex === 0}
          onClick={() => setCurrentDocumentIndex((prev) => prev - 1)}
          data-cy="refra-catalog-view-documents-modal-previous-button"
        />
        <RefraCatalogDocumentPreview
          refractoryId={refractoryId}
          document={documents[currentDocumentIndex]}
        />
        <Button
          icon={mdiArrowRightThin}
          variant="secondary"
          square
          disabled={currentDocumentIndex === documents.length - 1}
          onClick={() => setCurrentDocumentIndex((prev) => prev + 1)}
          data-cy="refra-catalog-view-documents-modal-next-button"
        />
      </div>
    </Modal>
  )
}
